export enum GENDER {
  Female,
  Male
}

export interface IPatients {
  id?: number;
  userGender?: number;
  userIdentityNumber?: string;
  userMobile?: string;
  userName?: string;
}

interface State {
  patientList: Array<IPatients>;
}

const Patients = {
  state: {
    patientList: [] as Array<IPatients>
  },

  reducers: {
    // 在这里写纯函数来改变 state
    updateState(state: State, payload: State) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (_dispatch) => ({})
};

export default Patients;
